import { getAtalhosDB } from "@/db/sistema";
import axios from "axios";
import moment from "moment";
import usuarioStore from "./usuario";

const getDefaultState = () => {
  return {
    drawer: true,
    errorRequest: false,
    msgError: "",
    atalhos: [],
    sincronizacoes: [],
    loadingApp: false,
  };
};

const sistemaStore = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setDrawer(state, drawer) {
      state.drawer = drawer;
    },
    setErrorRequest(state, error) {
      state.errorRequest = error;
    },
    setMsgError(state, msgError) {
      state.msgError = msgError;
    },
    setAtalhos(state, atalhos) {
      state.atalhos = atalhos;
    },
    setSincronizacoes(state, lista) {
      state.sincronizacoes = lista;
    },
  },
  actions: {
    async validarToken() {
      await axios.get("/nutricao-animal/usuario/valida-token");
    },
    async getAtalhosIniciais(context) {
      context.commit("setAtalhos", []);
      if (navigator.onLine) {
        await axios
          .get("/nutricao-animal/sistema/atalhos-iniciais")
          .then((res) => {
            if (res.data.success) {
              context.commit("setAtalhos", res.data.data);
            }
          });
      } else {
        var atalhos = await getAtalhosDB();
        context.commit("setAtalhos", atalhos);
      }
    },
  },
  getters: {
    isModeDevelopment() {
      return process.env.NODE_ENV.toLowerCase() == "development";
    },
    device() {
      if ("ontouchstart" in document.documentElement) {
        return 1;
      }

      return 2;
    },
    headerPropsTabela() {
      return {
        sortByText: "Ordenar por",
      };
    },
    sincronizouApp(state) {
      if (usuarioStore.state.usuarioLogado.representante) {
        return (
          state.sincronizacoes.findIndex(
            (s) =>
              s.data == moment().format("YYYY-MM-DD") &&
              s.codvendedor == usuarioStore.state.usuarioLogado.codrepresentante
          ) >= 0
        );
      }
      return (
        state.sincronizacoes.findIndex(
          (s) => s.data == moment().format("YYYY-MM-DD")
        ) >= 0
      );
    },
    precisaSincronizar(state, getters) {
      if (getters.device() == 1) {
        if (!getters.sincronizouApp(state)) {
          if (usuarioStore.state.usuarioLogado.obrigatorio_sincronizar) {
            state.errorRequest = true;
            state.msgError =
              "É necessário sincronizar os dados antes de emitir pedidos!";
            return true;
          }
        }
      }
      return false;
    },
  },
};

export default sistemaStore;
